import React from 'react';
import { observer } from 'mobx-react-lite';
import { useAppStateContext } from 'src/AppState/AppState';
import { ArrowIconWrapper, MenuButtonWrapper } from 'src/components/Menu/Menu.style';
import { SubmenuItemsNavigationSettings } from 'src/components/SystemSettingsForm/SystemSettingsSubmenu.style';

type SystemSettingSubmenuRouteType =
    | 'bog-settings'
    | 'bet-limit-settings'
    | 'widget-settings'
    | 'cash-out-settings'
    | 'bet-referral-feature';


export const SystemSettingsSubmenu = observer((): JSX.Element | null => {
    const { routerBackoffice } = useAppStateContext();
    const customerParams = routerBackoffice.getParametersString('global', 'tab.tab') ?? 'bog-settings';

    const isTabActive = (label: string): boolean => {
        return customerParams === label;
    };

    interface MenuItems {
        id: SystemSettingSubmenuRouteType;
        label: string;
        onClick: () => void;
    }

    const menuItems: Array<MenuItems> = [
        {
            id: 'bog-settings',
            label: 'BOG settings',
            onClick: (): void => routerBackoffice.redirectToBogSettings(),
        },
        {
            id: 'bet-limit-settings',
            label: 'Bet limit settings',
            onClick: (): void => routerBackoffice.redirectToBetLimitSettings(),
        },
        {
            id: 'widget-settings',
            label: 'Widget configs',
            onClick: (): void => routerBackoffice.redirectToWidgetConfigs(),
        },
        {
            id: 'cash-out-settings',
            label: 'Cash out settings',
            onClick: (): void => routerBackoffice.redirectToCashOutSettings(),
        },
        {
            id: 'bet-referral-feature',
            label: 'Bet referral',
            onClick: (): void => routerBackoffice.redirectToBetReferralFeature(),
        },
    ];

    return (
        <SubmenuItemsNavigationSettings>
            {menuItems.map(linkItem => (
                <MenuButtonWrapper
                    key={linkItem.id}
                    isActive={isTabActive(linkItem.id)}
                    onClick={linkItem.onClick}
                >
                    {linkItem.label}
                    <ArrowIconWrapper isActive={isTabActive(linkItem.id)} position='right' />
                </MenuButtonWrapper>
            ))}
        </SubmenuItemsNavigationSettings>
    );
});
